module.exports = __webpack_public_path__ + "img/15.130b752f.jpg";